import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';

import { TEAM_KEY, TeamResponse, updateTeamGuid } from '../utils/backend-api/teams';
import useCurrentUser from './useCurrentUser';

export default function useTeamRefreshGuid() {
  const queryClient = useQueryClient();
  const { currentUser } = useCurrentUser();
  const { data, mutate, mutateAsync, isLoading } = useMutation(() => updateTeamGuid(), {
    onSuccess: (data: TeamResponse) => {
      if (data.success) {
        toast.success('Team signup link has been updated.');
      }
      queryClient.setQueryData([TEAM_KEY, currentUser.guid], data);
    },
    onError: () => {
      toast.error('Team signup link was not updated, please try again.');
    },
  });

  return {
    refreshTeamGuidData: data,
    refreshTeamGuid: mutate,
    refreshTeamGuidAsync: mutateAsync,
    isRefreshTeamGuidLoading: isLoading,
  };
}
